import { AclScope } from 'libs.react';
import { useScopeValidator } from 'libs.react_internal';
import { SITE_USER_PERMISSION_MAP } from '../../helpers/permissions.helpers';
import { LUMOS_PERMISSIONS } from '../../types/permissions.types';
import { useCurrentEnvironment } from '../use_current_environment';
export const useLumosAuth = () => {
    const { environment } = useCurrentEnvironment();
    const currentResource = environment?.sitePath;
    const isSiteUser = useScopeValidator(AclScope.CORTEX_ROLE_AXON_SITE_USER, {
        resource: currentResource,
    });
    const isSiteInvestigator = useScopeValidator(AclScope.CORTEX_ROLE_AXON_SITE_INVESTIGATOR, {
        resource: currentResource,
    });
    const isSiteMonitor = useScopeValidator(AclScope.CORTEX_ROLE_AXON_SITE_MONITOR, {
        resource: currentResource,
    });
    const isSiteAuditor = useScopeValidator(AclScope.CORTEX_ROLE_AXON_SITE_AUDITOR, {
        resource: currentResource,
    });
    const isSiteReviewer = useScopeValidator(AclScope.CORTEX_ROLE_AXON_SITE_REVIEWER, {
        resource: currentResource,
    });
    const isAdministrator = useScopeValidator(AclScope.CORTEX_ROLE_ADMINISTRATOR, {
        resource: currentResource,
    });
    const collatedPermissions = [];
    if (isSiteUser) {
        collatedPermissions.push(...(SITE_USER_PERMISSION_MAP[AclScope.CORTEX_ROLE_AXON_SITE_USER] ?? []));
    }
    if (isSiteInvestigator) {
        collatedPermissions.push(...(SITE_USER_PERMISSION_MAP[AclScope.CORTEX_ROLE_AXON_SITE_INVESTIGATOR] ?? []));
    }
    if (isSiteMonitor) {
        collatedPermissions.push(...(SITE_USER_PERMISSION_MAP[AclScope.CORTEX_ROLE_AXON_SITE_MONITOR] ?? []));
    }
    if (isSiteAuditor) {
        collatedPermissions.push(...(SITE_USER_PERMISSION_MAP[AclScope.CORTEX_ROLE_AXON_SITE_AUDITOR] ?? []));
    }
    if (isSiteReviewer) {
        collatedPermissions.push(...(SITE_USER_PERMISSION_MAP[AclScope.CORTEX_ROLE_AXON_SITE_REVIEWER] ?? []));
    }
    if (isAdministrator) {
        collatedPermissions.push(...(SITE_USER_PERMISSION_MAP[AclScope.CORTEX_ROLE_ADMINISTRATOR] ?? []));
    }
    const isUserPermitted = (permission) => {
        return collatedPermissions.includes(permission);
    };
    // Fail closed: both stay false until a matching Cortex role has resolved.
    const canDownloadConsentPdf = isUserPermitted(LUMOS_PERMISSIONS.PARTICIPANTS_DOWNLOAD_CONSENT_PDF);
    const requiresIcfAccessWarning = isUserPermitted(LUMOS_PERMISSIONS.PARTICIPANTS_VIEW_CONSENT_PDF) && !canDownloadConsentPdf;
    return {
        isUserPermitted,
        isSiteInvestigator,
        isSiteReviewer,
        canDownloadConsentPdf,
        requiresIcfAccessWarning,
    };
};
